import React, {useState} from "react";
import InputComponent from "../../../../componennts/input";
import Select from 'react-select';

function PhoneFieldComponent(props){

    const fields = [
        {
            type: 'tel',
            required: true,
            placeholder: "Номер телефону",
            field: "phone",
            css: "w-25 border-end"
        },
        {
            type: 'text',
            required: true,
            placeholder: "TG ID",
            field: "tg_id",
            css: "w-25 border-end"
        },
        {
            type: 'text',
            required: true,
            placeholder: "WhatsApp",
            field: "whatsapp",
            css: "w-25 border-end"
        },
        {
            type: 'text',
            required: false,
            placeholder: "Viber",
            field: "viber",
            css: "w-25 border-end"
        },
        {
            type: 'text',
            required: true,
            placeholder: "Теги",
            field: "tags",
            css: "w-100"
        }
    ];

    return <>
        <div className="d-flex flex-wrap justify-content-between align-items-center border">
            {
                fields.map((field, i) =>  <InputComponent
                    id={props.id}
                    type={field.type}
                    name={props.id + '_phone-'+field.field}
                    value={props.value.note}
                    onChange={(e) => props.onChange(props.id, e, field.field)}
                    placeholder={field.placeholder + ' ' + (field.required ? '*' : '')}
                    class={'form-control rounded-0 border-0 border-bottom ' + field.css}
                />)
            }

            {/*<Select*/}
            {/*    options={options}*/}
            {/*    value={selectedOptions}*/}
            {/*    onChange={setSelectedOptions}*/}
            {/*    isMulti={true} // Enables tokenized tags / pills*/}
            {/*    isSearchable={true} // Enables typing to filter options*/}
            {/*    isClearable={true} // Adds an 'x' button to clear selections*/}
            {/*    placeholder="Select your tech stack..."*/}
            {/*/>*/}

            {/*{props.id === 0 && <button onClick={props.add} className={'btn btn-secondary rounded-0'}>+</button>}*/}
            {/*{props.id !== 0 && <button onClick={props.remove} className={'btn btn-outline-danger rounded-0'}>-</button>}*/}
        </div>
    </>
}

export default PhoneFieldComponent;
